import { hover } from 'pobble-components/dist/jss-mixins'

export default ({ COLORS }) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #ddd',
    marginTop: '-1px',
    '& textArea': {
      '-webkit-appearance': 'none',
      resize: 'none',
      border: 'none',
      background: 'none',
      color: '#999',
      padding: '10px',
      '&::placeholder': {
        color: '#BBBBBB'
      }
    }
  },
  dragging: {
    borderRadius: '0 !important'
  },
  first: {
    borderRadius: '4px 4px 0 0'
  },
  last: {
    borderBottom: '1px solid #ddd',
    borderRadius: '0 0 4px 4px'
  },
  handle: {
    color: '#bbb',
    margin: '0 0 0 10px',
    cursor: 'move',
    width: '16px',
    height: '16px'
  },
  criteria: {
    flex: '1'
  },
  prompts: {
    width: '200px'
  },
  separator: {
    width: '1px',
    height: '20px',
    background: '#ddd'
  },
  deleteButton: {
    cursor: 'pointer',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL,
    marginRight: '10px',
    ...hover({
      color: COLORS.BLUE.FADED
    })
  }
})
